// extracted by mini-css-extract-plugin
export default {"cls1":"ResultsList-DisplayListItemInner_cls1__9qfCA","cls2":"ResultsList-DisplayListItemInner_cls2__blxkE ResultsList-DisplayListItemInner_cls1__9qfCA"};